// extracted by mini-css-extract-plugin
export default {"contents":"style_contents__1G7pS","page-content-container":"style_page-content-container__PqGmg","footer":"style_footer__VNArg"};